import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from "@material-ui/core";

const SUBCATEGORIES = [
  {
    title: "Troca de cartão",
    value: "troca_cartao",
    guidance: [
      <><strong>Existem duas formas de fazer a troca de cartão:</strong></>,
      <><strong>APP:</strong> É a forma mais eficaz. O cliente acessa o app e realiza a troca.</>,
      <><strong>LINK:</strong> O cliente precisa receber e acessar o link. Se o e-mail não chegar, teste outro endereço, inclusive o da loja.</>,
      <><strong>Se a troca for feita</strong>, mas a <strong>cobrança não for aprovada</strong>, oriente o cliente a tentar <strong>outro cartão</strong> ou <strong>entrar em contato com o banco</strong>.</>,
      <>Para acessar o <strong>APP</strong>, confira na <strong>Agenda</strong> se <strong>CPF</strong> e <strong>TELEFONE</strong> estão corretos e oriente o cliente a <strong>ATUALIZAR</strong> o <strong>APP</strong>.</>,
    ],
  },
  {
    title: "Recobrança",
    value: "recobranca",
    guidance: [
      <>A <strong>RECOBRANÇA</strong> agora é feita pela <strong>AGENDA</strong>: <code>Assinantes {'->'} CPF {'->'} Olho {'->'} cobranças {'->'} Recobrança</code></>,
      <>Lembrando que o <strong>banco precisa autorizar a cobrança</strong> e o cliente precisa <strong>ter saldo</strong>.</>,
      <>Caso não dê certo, o cliente precisa <strong>trocar o cartão</strong>.</>,
      <>A troca de cartão é feita <strong>VIA APP</strong>.</>,
    ],
  },
  {
    title: "Estorno",
    value: "estorno",
    guidance: [
      <>A <strong>ESTORNO</strong> agora é feita pela <strong>AGENDA</strong>: <code>Assinantes {'->'} CPF {'->'} Olho {'->'} cobranças {'->'} ESTORNO</code></>,
      <>Lembrando que o franqueado precisa ter <strong>saldo na conta da Vindi</strong>.</>,
      <>Quando você realiza o estorno e ele aparece como <strong>estornado</  strong>, significa que a Petland já solicitou a devolução do valor para o cartão.</>,
      <>Porém, alguns cartões estornam na hora, outros em <strong>7 dias, 30 dias ou até 60 dias</strong>.</>,
      <><strong>Não temos controle sobre esse prazo e nem acesso a essa informação.</strong></>,

    ],
  },
  {
    title: "Erro na cobrança",
    value: "erro_cobranca",
    guidance: [
      <>Agora você consegue <strong>recobrar</strong> e também <strong>visualizar o erro da cobrança</strong> direto pela <strong>AGENDA</strong>: <code>Assinantes {'->'} CPF {'->'} Olho {'->'} cobranças</code></>,
      <>Dependendo do motivo, o cliente precisa <strong>trocar o cartão</strong>.</>,
      <>Em alguns casos, também pode ser necessário entrar em contato com o <strong>banco</strong> ou utilizar <strong>outro cartão, inclusive de outro titular</strong>.</>,
    ],
  },
  {
    title: "Cancelamento",
    value: "cancelamento",
    guidance: [
      <>O cancelamento é feito <strong>100% pelo APP</strong>.</>,
      <>Oriente o cliente a <strong>acessar o APP e cancelar por lá</strong>. A assinatura é <strong>cancelada em segundos</strong>.</>,
      <>Para acessar o <strong>APP</strong>, confira na <strong>Agenda</strong> se <strong>CPF</strong> e <strong>TELEFONE</strong> estão corretos e oriente o cliente a <strong>ATUALIZAR</strong> o <strong>APP</strong>.</>,
      <>Se essas informações estiverem incorretas, o cliente pode ter erro ao tentar entrar no app.</>,
    ],
  },
  {
    title: "Troca de plano",
    value: "troca_plano",
    guidance: [
      <><strong>Existem duas formas de fazer a troca de PLANO:</strong></>,
      <>A troca de plano sempre acontece na <strong>próxima cobrança</strong>.</>,
      <><strong>APP:</strong> É a forma mais eficaz. O cliente acessa o app e realiza a troca.</>,
      <><strong>LINK:</strong> O cliente precisa receber e acessar o link. Se o e-mail não chegar, teste outro endereço, inclusive o da loja.</>,
      <>Para acessar o<strong>APP</strong>, confira na <strong>Agenda</strong> se <strong>CPF</strong> e <strong>TELEFONE</strong> estão corretos e oriente o cliente a <strong>ATUALIZAR</strong> o <strong>APP</strong>.</>,
      <>Se essas informações estiverem incorretas, o cliente pode ter erro ao tentar entrar no app.</>,
    ],
  },
  {
    title: "Reajuste ativos",
    value: "reajuste_ativos",
    guidance: [
      <>O <strong>REAJUSTE</strong> agora é feita pela <strong>AGENDA</strong>: <code>Assinantes {'->'} CPF {'->'} Olho {'->'} reajuste</code></>,
      <>Lembre-se de que o reajuste precisa <strong>seguir as regras exibidas na própria tela</strong>.</>,
    ],
  },
  {
    title: "Reajuste novos",
    value: "reajuste_novos",
    guidance: [
      <>O <strong>REAJUSTE</strong> agora é feita pela <strong>AGENDA</strong>: <code>Assinatura {'->'} Configurações</code></>,
      <>Lembre-se de que o reajuste precisa <strong>seguir as regras exibidas na própria tela</strong>.</>,
    ],
  },
];

const useStyles = makeStyles((theme) => ({
  card: {
    height: "100%",
    border: "1px solid #E8EAF6",
    borderRadius: 8,
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      borderColor: "#F97B18",
      boxShadow: "0 8px 22px rgba(249, 123, 24, 0.15)",
    },
  },
  selectedCard: {
    borderColor: "#F97B18",
    boxShadow: "0 8px 22px rgba(249, 123, 24, 0.15)",
  },
  guidance: {
    lineHeight: 1.7,
    marginBottom: theme.spacing(1.5),
  },
  actions: {
    display: "flex",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
    marginTop: theme.spacing(2),
  },
  primaryButton: {
    backgroundColor: "#F97B18",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#D05D02",
    },
  },
}));

function SubscriptionSubcategoryCards({ onResolved, onOpenForm, selectedSubcategory }) {
  const classes = useStyles();
  const [selected, setSelected] = useState(
    SUBCATEGORIES.find((item) => item.value === selectedSubcategory) || null
  );

  const handleSelect = (item) => {
    setSelected(item);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Assinatura
      </Typography>
      <Typography variant="body2" color="textSecondary" paragraph>
        Selecione o assunto para ver a orientação antes de abrir o chamado.
      </Typography>

      <Grid container spacing={2}>
        {SUBCATEGORIES.map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item.value}>
            <Card className={`${classes.card} ${selected?.value === item.value ? classes.selectedCard : ""}`}>
              <CardActionArea onClick={() => handleSelect(item)} style={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                    {item.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      {selected && (
        <Box marginTop={3} padding={2.5} border="1px solid #e9ecef" borderRadius={8} bgcolor="#f8f9fa">
          <Typography variant="h6" gutterBottom>
            {selected.title}
          </Typography>
          {selected.guidance.map((paragraph, index) => (
            <Typography key={index} variant="body2" className={classes.guidance}>
              {paragraph}
            </Typography>
          ))}

          <Box marginTop={3}>
            <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
              Mesmo assim deseja abrir o chamado?
            </Typography>
            <Box className={classes.actions}>
              <Button variant="outlined" onClick={onResolved}>
                Não
              </Button>
              <Button
                variant="contained"
                className={classes.primaryButton}
                onClick={() => onOpenForm(selected.value)}
              >
                Sim, abrir chamado
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export { SUBCATEGORIES };
export default SubscriptionSubcategoryCards;
